import styled from "@emotion/styled";

export const Table = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MacroRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 1rem 0;
  border-top: 1px solid var(--color-light-gray, #e6e3db);
`;

export const CaloriesRows = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  padding: 1rem 1rem 0;
  border-top: 1px solid var(--color-light-gray, #e6e3db);
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.375rem;
  letter-spacing: -0.32px;
`;

export const MacroIcon = styled.span<{ $color: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${(props) => props.$color};

  svg {
    flex-shrink: 0;
    width: 1.1875rem;
    height: 1.1875rem;
  }
`;

export const Label = styled.span`
  flex: 1 0 0;
  min-width: 0;
  word-break: break-word;
  color: var(--color-charcoal-80, rgba(33, 33, 33, 0.8));
`;

export const Value = styled.span<{ $color: string }>`
  flex-shrink: 0;
  white-space: nowrap;
  text-align: right;
  color: ${(props) => props.$color};
`;
